'use client';
export { AspectRatio } from '@chakra-ui/react';

//# sourceMappingURL=index.js.map